<template>
  <ExternalQueryList
      headline="Events"
      endpoint="/api/v2/content-events"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      @show="contentEvent => $router.push(getUrl(contentEvent))"
  >
    <template v-slot:default="{ row: contentEvent }">
      <td class="table__ellipsis">
        <router-link :to="getUrl(contentEvent)">
          {{ contentEvent.attributes.title }}
        </router-link>
      </td>

      <td>
        <div style="display: flex; justify-content: space-between">
          <div>
            {{ contentEvent.attributes.portal_company_name }}
          </div>

          <div style="white-space:nowrap;">
            <i
                v-if="contentEvent.attributes.company_has_active_partnership && !contentEvent.attributes.portal_company_is_editorial"
                class="fa fa-book-reader"
                v-tooltip="'Active subscription'"
            />
          </div>
        </div>
      </td>

      <td>
        {{ contentEvent.attributes.publish_at | datetime }}
      </td>

      <td>
        <Avatar v-if="contentEvent.attributes.author_initials" :color="contentEvent.attributes.author_color">
          {{ contentEvent.attributes.author_initials }}
        </Avatar>
      </td>

      <td>
        <span v-if="!contentEvent.attributes.publish_at || !isPast(contentEvent.attributes.publish_at)" class="label label-info">
          Draft
        </span>

        <span v-else-if="isPast(contentEvent.attributes.unpublish_at)" class="label label-warning">
          Unpublished
        </span>

        <span v-else class="label label-success">
          Published
        </span>
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/events/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import moment from 'moment'
import Avatar from '../../../Avatar'
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {Avatar, ExternalQueryList},

  props: {
    portal: {
      required: true
    },

    users: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 11, text: 'Title'},
        {width: 4, text: 'Company'},
        {width: 3, text: 'Publish At'},
        {width: 2, text: 'User'},
        {width: 2, text: 'Status'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 13,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'select',
            name: 'user_id',
            placeholder: 'Search users...',
            nullable: true,
            options: this.users.map(user => ({
              value: user.id,
              label: user.attributes.full_name
            }))
          },
          {
            width: 4,
            widget: 'typeahead',
            name: 'company_id',
            placeholder: 'Search companies...',
            endpoint: '/api/v2/companies'
          },
          {
            width: 3,
            widget: 'submit'
          }
        ]
      ]
    },
  },

  methods: {
    getUrl(contentEvent) {
      return '/portals/' + this.portal.id + '/content/events/' + contentEvent.id + '/edit'
    },

    isPast(value) {
      return moment().isAfter(value)
    }
  }
}
</script>
